<template>
  <b-form @submit="onSubmit" class="modal-cost-view-wrap">

    <!-- MAIN -->
    <div class="mastermodal-view-wrap" style="gap: 0.5rem;">
      <div class="mastermodal-view--left">
        <div class="mastermodal-mobile-status">
          <CostStatusBadge :cost="cost" @toggle-complete="toggleComplete" />
        </div>
        <!-- left content here -->
        <overlay-scrollbars :options="{ scrollbars: { autoHide: 'never' }, overflowBehavior: { y: 'scroll', x: 'hidden' }, className : 'os-theme-dark os-theme-gekko' }">
          <div class="mastermodal-view-tabs--details" style="padding: 0;">
            

            <div class="modal-form-legend">
              <legend v-translate>Basic cost data</legend>
            </div>

            <!-- Description -->
            <b-form-group id="input-group-4" label-class="gk-label-margin gk-modal-label" :label="$gettext('Description')" label-for="input-4">
              <b-form-input data-analytics-click id="input-4" v-model="cost.description" :placeholder="$gettext('Lunch, new laptop, business cards')" />
            </b-form-group>

            <!-- Amount Total -->
            <b-form-group v-if="showField('amount')" id="input-group-5" label-class="gk-label-margin gk-modal-label" label-for="input-5">
              <template slot="label">
                {{ $gettext('Total (inc. VAT)') }} <span v-if="showAIfieldsAmount" class='ai-icon'>Ai</span>
              </template>
              <b-input-group>
                <b-form-input id="input-5" type="number" v-model="cost.amount" placeholder="0.0" step="0.01" />
              </b-input-group>
            </b-form-group>

            <!-- Amount Subtotal -->
            <b-form-group v-if="showField('subtotal_amount')" id="input-group-5" label-class="gk-label-margin gk-modal-label" label-for="input-5">
              <template slot="label">
                {{ $gettext('Total (ex. VAT)') }} <span v-if="showAIfieldsAmount" class='ai-icon'>Ai</span>
              </template>
              <b-input-group>
                <b-form-input id="input-5" type="number" v-model="cost.subtotal_amount" placeholder="0.0" step="0.01" />
              </b-input-group>
            </b-form-group>

            <!-- VAT -->
            <b-form-row>
              <b-col v-for="a_cost_line, index in cost.cost_lines" :key="'taxrate-' + index" cols="12" :lg="(cost.cost_lines.length % 2 != 0 && (index == (cost.cost_lines.length - 1))) ? 12 : 6">
                <b-form-group id="input-group-7" class="vat-input-size" label-class="gk-label-margin gk-modal-label" label-for="input-7">
                  <template slot="label">
                    {{ $gettext('VAT') + ' ' + a_cost_line.tax_rate + '%' }} <span v-if="showAIfieldsVAT" class='ai-icon'>Ai</span>
                  </template>
                  <b-input-group>
                    <template #append>
                      <b-input-group-text class="btn" @click="calculate(a_cost_line)" :disabled="disableTaxFields()">
                        <font-awesome-icon icon="fa-regular fa-calculator" class="append-icon" />
                      </b-input-group-text>
                    </template>
                    <b-form-input id="input-7" type="number" v-model="a_cost_line.amount" placeholder="0.0" step="0.01" :disabled="disableTaxFields()" />
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-form-row>

            <b-form-row>
              
              <!-- Retention % -->
              <b-col cols="12" lg="6">
                <b-form-group v-if="showField('retention')" id="input-group-6" label-class="gk-label-margin gk-modal-label" :label="$gettext('Retention')" label-for="input-6">
                  <b-input-group append="%">
                    <b-form-input data-analytics-click id="input-6" type="number" v-model="cost.retention_tax_percentage" :placeholder="$gettext('15.0%')" step="0.01" :disabled="disableTaxFields()" />
                  </b-input-group>
                </b-form-group>
              </b-col>

              <!-- Retention Amount -->
              <b-col cols="12" lg="6">
                <b-form-group v-if="showField('retention')" id="input-group-6" label-class="gk-label-margin gk-modal-label" :label="$gettext('Amount')" label-for="input-6">
                  <b-input-group>
                    <template #append>
                      <b-input-group-text class="btn" @click="calculateRetentionAmount" :disabled="disableTaxFields()">
                        <font-awesome-icon icon="fa-regular fa-calculator" class="append-icon" />
                      </b-input-group-text>
                    </template>
                    <b-form-input id="input-6" type="number" v-model="cost.retention_tax_amount" placeholder="0.0" step="0.01" :disabled="disableTaxFields()" />
                  </b-input-group>
                </b-form-group>
              </b-col>

            </b-form-row>

            <b-row>
              <b-col>
                <!-- TAX Exempt switch -->
                <b-form-group id="input-group-8" label-class="gk-label-margin gk-modal-label">
                  <b-form-checkbox id="input-8" class="checkbox-bg-color" style="font-size: 14px;" v-model="cost.tax_exempt" :disabled="cost.btw_reversed_charge" switch>
                    <span v-translate>Exempt from tax</span>&nbsp;
                    <span v-b-tooltip.hover :title="$gettext('Indicates that no VAT/sales tax will be paid on this cost item.')">
                      <font-awesome-icon icon="fa-regular fa-circle-question" class="tooltip-icon tooltip-icon--question" />
                    </span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col>
                <!-- Reversed charge switch -->
                <b-form-group id="input-group-9" label-class="gk-label-margin gk-modal-label">
                  <b-form-checkbox id="input-9" class="checkbox-bg-color" style="font-size: 14px;" v-model="cost.btw_reversed_charge" :disabled="cost.tax_exempt" switch>
                    <span v-translate>Reversed charge</span>&nbsp;
                    <span v-b-tooltip.hover :title="$gettext('Indicates that no VAT/sales tax has been paid yet on this item. The buyer is responsible to account and report unpaid VAT/sales tax.')">
                      <font-awesome-icon icon="fa-regular fa-circle-question" class="tooltip-icon tooltip-icon--question" />
                    </span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>

            <b-form-row>
              <b-col cols="12" :lg="(!transactionCost) ? 6 : 12">
                <!-- Cost type -->
                <b-form-group id="input-group-6" label-class="gk-label-margin gk-modal-label" :label="$gettext('Cost type*')" label-for="input-6">
                  <CostTypeSelector v-model="cost.cost_type" @change="onCostTypeChange" />
                  <template #description>
                    <GekkoButton 
                      @click="redirectCostTypes" 
                      :text="$gettext('Add cost categories')" 
                      icon="fa-solid fa-plus" 
                      class="text-info p-0 w-100 whitesp-normal"
                      size="sm"
                      variant="link"
                    />
                  </template>
                </b-form-group>
              </b-col>
            </b-form-row>

            

          </div>

          <div v-if="!showExtraFields" class="p-3" style="border-top: 1px solid rgba(0, 0, 0, 0.1);">
            <GekkoButton 
              @click="showExtraFields = true" 
              :text="$gettext('Show all fields')" 
              icon="fa-solid fa-chevron-down" 
              class="w-100 text-info whitesp-normal"
              variant="link"
            />
          </div>

          <div v-show="showExtraFields">
            <b-form-row>

              <!-- Date -->
              <b-col cols="12" lg="6">
                <b-form-group id="input-group-1" label-class="gk-label-margin gk-modal-label" label-for="input-1">
                  <template slot="label">
                    {{ $gettext('Cost date') }} <span v-if="showAIfieldsDate" class='ai-icon'>Ai</span>
                  </template>
                  <b-form-datepicker id="input-1" class="inline-form-datepicker" v-model="cost.date" no-flip initial-date="2021-01-01" :date-format-options="{ year: 'numeric', month: 'short', day: 'numeric' }" />
                </b-form-group>
              </b-col>

              <!-- Number -->
              <b-col cols="12" lg="6">
                <b-form-group id="input-group-2" label-class="gk-label-margin gk-modal-label" :label="$gettext('Cost number*')" label-for="input-2">
                  <b-form-input data-analytics-click id="input-2" v-model="cost.number" required :placeholder="$gettext('2020-000001')" @input="costNumberChange" />
                </b-form-group>
              </b-col>

            </b-form-row>

            <!-- Number on document -->
            <b-form-group v-if="showField('number_on_document')" id="input-group-3" label-class="gk-label-margin gk-modal-label" :label="$gettext('Number on document')" label-for="input-3">
              <b-form-input data-analytics-click id="input-3" v-model="cost.number_on_document" />
            </b-form-group>

            <!-- Supplier -->
            <b-form-group id="input-group-5" label-class="gk-label-margin gk-modal-label" label-for="input-5">
              <template slot="label">
                {{ $gettext('Supplier') }} <span v-if="showAIfieldsSupplier" class='ai-icon'>Ai</span>
              </template>
              <b-form-group>
                <CustomerSelector v-model="cost.supplier" :filters="{is_supplier:'True', owner_company: getCompanyId, is_archived:'False'}" />
              </b-form-group>
            </b-form-group>

            <!-- Payment type -->
            <b-form-row>
              <b-col cols="12" lg="6">
                <b-form-group id="input-group-10" label-class="gk-label-margin gk-modal-label" :label="$gettext('Payment type')" label-for="input-10">
                  <PaymentTypeSelector v-model="cost.payment_type" />
                </b-form-group>
              </b-col>
            </b-form-row>

            <!-- Customer -->
            <b-form-group id="input-group-10" label-class="gk-label-margin gk-modal-label" :label="$gettext('Customer')" label-for="input-10">
              <b-form-group>
                <CustomerSelector v-model="cost.customer" @change="customerCallback" :filters="{is_customer:'True', owner_company: getCompanyId, is_archived:'False'}" />
              </b-form-group>
            </b-form-group>
            <b-form-group id="input-group-10" label-class="gk-label-margin gk-modal-label" :label="$gettext('Project')" label-for="input-10">
              <b-form-select v-model="cost.project" :disabled="projectList.length === 0">
                <b-form-select-option v-for="project in projectList" :value="project.id" :key="project.id">
                  {{project.name}}
                </b-form-select-option>
              </b-form-select>
            </b-form-group>

            <!-- Transactions list -->
            <CostTransactions :costId="cost.id" />

          </div>

        </overlay-scrollbars>
        
      </div> <!-- mastermodal-view--left end -->

      <div class="mastermodal-view--right modal-dropzone-actions" :class="{ 'expanded': previewExpanded }" style="padding: 0;">
        <div class="mastermodal-view--right__handle" @click="previewExpanded = !previewExpanded"/>
        <div class="mastermodal-view--right__document">
          
          <div class="modal-dropzone-actions--wrap">
            <div class="modal-main-actions">
              <SmartScanSwitch @change="onSmartScanChange" />
              <div v-if="scanning || emptyScan" class="w-100">
                <ProgressBar v-if="scanning" class="w-50 ml-3" />
                <div class="hint" v-if="emptyScan">We could not find any data. Try again or upload a different file.</div>
              </div>
            </div>
            <div class="modal-dropzone-wrapper">
              <VueDropzone :preloaded_file="imageSrc" :allowed-files="'all'" :onlyChange="true" @change="fileChanged" />
            </div>
          </div>
          
        </div> <!-- mastermodal-view--right__document end -->

        <div class="mastermodal-view--right__statuswrap">
          <CostStatusBadge :cost="cost" @toggle-complete="toggleComplete" />
        </div> <!--  mastermodal-view--right__statuswrap end -->
      </div> <!-- mastermodal-view--right end -->
    </div> <!-- mastermodal-view-wrap end -->

  </b-form>
</template>
<script>
import EditCost from "@/components/costs/EditCost.vue";
import { mapGetters } from "vuex";

export default {
  name: "BankCreateCost",
  extends: EditCost,
  data () {
    return {
      showExtraFields: false
    }
  },
  computed: {
    ...mapGetters ({
      getCompanyId: 'main/getCompanyId'
    })
  },
  created () {
  },
  methods: {
  }
}
</script>
